/**
* @see /client/containers/RestaurantsList/index.js
* @see /client/containers/GfitCardsList/index.js
* @see /client/containers/RedeemZsc/index.js
* ListFilters
*/

import React, { PureComponent } from 'react';
import { bool, string, func, array } from 'prop-types';
// import FontAwesomeIcon from 'react-fontawesome';

import { ListStyle } from './StyledListFilters';
import Checkbox from '../Checkbox';
import Input from '../Input';
import SubTitle from '../TitleTypography/SubTitle';

const renderFitlers = (filters, onChange, payloadKey, { showSubFilterId, showSubFilter, isParentFilter, selectedCategories = [] } = {}) => (
  filters && filters.map((filter) => {
    const { filterName, count, isChecked, id, name, sub_categories } = filter;
    let isCheckedValue = false;
    switch (payloadKey) {
      case 'type':
        if (selectedCategories.includes(id)) {
          isCheckedValue = true;
        }
        break;
      case 'discount':
        if (selectedCategories.includes(filterName)) {
          isCheckedValue = true;
        }
        break;
      default:
        isCheckedValue = isChecked;
        break;
    }
    return (
      (filterName || name) ?
        <li key={filterName + count + id}>
          <div className="wrapperFlex">
            <Checkbox
              id={id || filterName}
              onChange={(_payloadKey, _id, checked, _name) => onChange(_payloadKey, _id, checked, _name, { isParentFilter, parentId: showSubFilterId })}
              isChecked={isCheckedValue}
              payloadKey={payloadKey}
              name={filterName}
              key={Math.random()}
            >
              <strong>{name || filterName}</strong>
              {count && <span>{count}</span>}
            </Checkbox>
            {sub_categories && sub_categories.length ?
              <span onClick={() => showSubFilter(id)} role="presentation" className="icon">{showSubFilterId === id ? '−' : '+' }</span>
              // <FontAwesomeIcon name={`${showSubFilterId === id ? 'minus' : 'plus'}`} onClick={() => showSubFilter(id)} />
              : null}
          </div>
          {showSubFilterId === id ?
            <ListFilters
              key={JSON.stringify(selectedCategories)}
              filters={sub_categories}
              onChange={onChange}
              payloadKey={payloadKey}
              selectedCategories={selectedCategories}
              showSubFilterId={showSubFilterId}
            /> : null}
        </li> : ''
    );
  })
);

function ListFilters(props) {
  const {
    filterTitle,
    filters,
    search,
    seeMore,
    mainTitle,
    onChange,
    payloadKey,
    seeMoreHandle,
    allFilters,
    isShowSubFilter,
    selectedCategories,
    showSubFilterId,
  } = props;
  return (
    <ListStyle>
      {mainTitle && <SubTitle fontWeight="800" className="font-18">{mainTitle}</SubTitle>}
      <ul>
        {filterTitle ? <SubTitle fontWeight="800" className="font-18">{filterTitle}</SubTitle> : ''}
        {search && <li><Input placeholder="Search" /></li>}
        {isShowSubFilter ?
          <RenderNestedFilters filters={filters} onChange={onChange} payloadKey={payloadKey} selectedCategories={selectedCategories} /> :
          renderFitlers(filters, onChange, payloadKey, { selectedCategories, showSubFilterId })}
        {seeMore &&
          <li onClick={() => seeMoreHandle(payloadKey, allFilters, filterTitle)} role="presentation">
            <span style={{ float: 'right' }}>More</span>
          </li>}
      </ul>
    </ListStyle>
  );
}

class RenderNestedFilters extends PureComponent {
  constructor() {
    super();
    this.state = { showSubFilterId: '' };
    this.handleInternalFilter = this.handleInternalFilter.bind(this);
  }

  handleInternalFilter(activeId) {
    const { showSubFilterId } = this.state;
    this.setState({ showSubFilterId: showSubFilterId !== activeId ? activeId : '' });
  }

  render() {
    const { filters, onChange, payloadKey, selectedCategories } = this.props;
    const { showSubFilterId } = this.state;
    return (renderFitlers(filters, onChange, payloadKey,
      { showSubFilterId, showSubFilter: this.handleInternalFilter, isParentFilter: true, selectedCategories }));
  }
}

ListFilters.defaultProps = {
  payloadKey: 'Checkbox',
  search: false,
  seeMore: false,
  filterTitle: '',
  mainTitle: '',
  showSubFilterId: '',
  filters: [],
  allFilters: [],
  selectedCategories: [],
  isShowSubFilter: false,
  seeMoreHandle: () => '',
  onChange: () => '',
};
ListFilters.propTypes = {
  search: bool,
  seeMore: bool,
  isShowSubFilter: bool,
  filterTitle: string,
  mainTitle: string,
  payloadKey: string,
  showSubFilterId: string,
  filters: array,
  onChange: func,
  seeMoreHandle: func,
  allFilters: array,
  selectedCategories: array,
};

RenderNestedFilters.defaultProps = {
  filters: [],
  selectedCategories: [],
};
RenderNestedFilters.propTypes = {
  filters: array,
  selectedCategories: array,
  onChange: func.isRequired,
  payloadKey: string.isRequired,
};

export { renderFitlers, RenderNestedFilters };
export default ListFilters;



// WEBPACK FOOTER //
// client/components/ListFilters/index.js